import Swal from 'sweetalert2'
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    title: String,
    text: String,
    icon: String,
    confirmText: String,
    cancelText: String,
  }

  connect() {
    this.redirect = false;
    this.isOpen = false;
  }

  sweetDeleteAlert(event) {
    if (this.redirect || this.isOpen) return;

    event.stopImmediatePropagation();
    event.preventDefault();

    let htmlContent = this.textValue || "Êtes-vous sûr de vouloir supprimer ?";

    this.isOpen = true;
    Swal.fire({
      title: this.titleValue || 'Attention !',
      text: this.textValue || 'Êtes-vous sûr de vouloir supprimer ?',
      html: htmlContent,
      icon: this.iconValue || 'warning',
      showCancelButton: true,
      confirmButtonText: this.confirmTextValue || 'Confirmer',
      cancelButtonText: this.cancelTextValue || 'Annuler',
      confirmButtonColor: '#DD6B55',
      cancelButtonColor: '#999'
    }).then((result) => {
      if (result.isConfirmed) {
        this.redirect = true;
        this.element.click();
      }
    }).finally(() => {
      this.isOpen = false;
    })
  }
}
